@let dealerSearchDto = this.dealerSearchDto();
@let displayOnlyJumpToSearchAction = this.displayOnlyJumpToSearchAction();
@let disableActionButtons = this.disableActionButtons();
@let index = this.index();

<div #card class="card" [style.height]="maxHeight()">
    <div class="header" [class.clickable]="displayOnlyJumpToSearchAction" (click)="jumpToDealerSearch.emit()">
        <div class="name">
            @if (dealerSearchDto.name) {
                {{ dealerSearchDto.name }}
            } @else {
                {{ 'YOUR_SPECIALIST_RETAILER_CONTACTS' | translate }}
                @if (index !== 0) {
                    {{ index + 1 }}
                }
            }
        </div>
        <div class="action-buttons">
            @if (!displayOnlyJumpToSearchAction) {
                <div class="visible-buttons" [class.disabled]="disableActionButtons">
                    <button id="visible-rename-btn" [disabled]="disableActionButtons" (click)="renameSearch.emit()">
                        <warema-icon class="rename-icon" icon="pen" />
                    </button>
                </div>
            }
        </div>
    </div>

    <div class="address-activity">
        <div class="address">
            <warema-icon class="address-button" icon="location" /> {{ dealerSearchDto.searchedText }}
        </div>
        <div class="activity">
            @switch (dealerSearchDto.activity) {
                @case (appointmentActivityType.ConsultationAtHome) {
                    <warema-icon class="activity-icon" icon="homeDetailed" />
                }
                @case (appointmentActivityType.ConsultationAtShowroom) {
                    <warema-icon class="activity-icon" icon="store" />
                }
                @case (appointmentActivityType.RepairOrService) {
                    <warema-icon class="activity-icon" icon="service" />
                }
            }
            {{ dealerSearchDto.activity.toString() | translate }}
        </div>
    </div>

    <div class="product-categories" [class.expanded]="isExpanded()">
        @if (externalProductSubcategories.length > 0) {
            <div class="category-sub-categories-wrapper">
                <div class="category">{{ 'PRODUCT_CATEGORY.fensteraussen' | translate }}</div>
                @for (external of externalProductSubcategories; track external) {
                    <div class="sub-category">
                        <div class="red-slash">/</div>
                        {{ 'PRODUCT_CATEGORY.' + external | translate }}
                    </div>
                }
            </div>
        }
        @if (insideProductSubcategories.length > 0) {
            <div class="category-sub-categories-wrapper">
                <div class="category">{{ 'PRODUCT_CATEGORY.fensterinnen' | translate }}</div>
                @for (inside of insideProductSubcategories; track inside) {
                    <div class="sub-category">
                        <div class="red-slash">/</div>
                        {{ 'PRODUCT_CATEGORY.' + inside | translate }}
                    </div>
                }
            </div>
        }
        @if (patioProductSubcategories.length > 0) {
            <div class="category-sub-categories-wrapper">
                <div class="category">{{ 'PRODUCT_CATEGORY.terrasse' | translate }}</div>
                @for (patio of patioProductSubcategories; track patio) {
                    <div class="sub-category">
                        <div class="red-slash">/</div>
                        {{ 'PRODUCT_CATEGORY.' + patio | translate }}
                    </div>
                }
            </div>
        }
        @if (controlProductSubcategories.length > 0) {
            <div class="category-sub-categories-wrapper">
                <div class="category">{{ 'PRODUCT_CATEGORY.steuerung' | translate }}</div>
                @for (control of controlProductSubcategories; track control) {
                    <div class="sub-category">
                        <div class="red-slash">/</div>
                        {{ 'PRODUCT_CATEGORY.' + control | translate }}
                    </div>
                }
            </div>
        }
    </div>

    @if (isOverflowing() && !isExpanded()) {
        <button
            class="more-info-btn"
            [class.with-action-buttons]="!displayOnlyJumpToSearchAction"
            (click)="expandCard()"
        >
            <label>{{ 'MORE_INFORMATION' | translate }}</label
            ><warema-icon icon="beakDown" />
        </button>
    } @else if (isExpanded()) {
        <button class="less-info-btn" (click)="shrinkCard()">
            <warema-icon icon="beakUp" />
            <label>{{ 'LESS_INFORMATION' | translate }}</label>
        </button>
    }
    <div class="tile-footer" [class.with-actions]="!displayOnlyJumpToSearchAction">
        @if (!displayOnlyJumpToSearchAction) {
            <warema-button
                size="small"
                type="tertiary"
                [disabled]="disableActionButtons"
                [iconRight]="'trashcan'"
                [text]="'DELETE' | translate"
                (click)="deleteSearch.emit()"
            />
            <warema-button
                size="small"
                type="tertiary"
                [disabled]="disableActionButtons"
                [iconRight]="'externalLink'"
                [text]="'OPEN_SEARCH' | translate"
                (click)="openSearch.emit()"
            />
        } @else {
            <warema-button
                size="small"
                type="primary"
                [iconRight]="'calendar'"
                [text]="'REQUEST_A_CONSULTATION' | translate"
                (click)="jumpToDealerSearch.emit()"
            />
        }
    </div>
</div>
